import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { TableInsurancePoliciesComponent } from '../../components/table-insurance-policies/table-insurance-policies.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
	standalone: true,
	selector: 'card-insurance-policies',
	templateUrl: './card-insurance-policies.component.html',
	imports: [ CommonModule, ListPagerComponent, TableInsurancePoliciesComponent, FormsModule ]
})
export class CardInsurancePoliciesComponent implements OnInit {
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.insurancePolicies = [];
		this.vm.pageSize = 10;
	}

	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
}